import { useState } from 'react'
import { number_to_price } from '../../../helper/common'
import {
  IconAutomatedTrafficFineNotificationServicesSelected,
  IconAutomatedTrafficFineNotificationServicesMoney,
  IconAutomatedTrafficFineNotificationServicesType
} from '../../../assets/icons'
import DraggableScroll from '../../BasicComponent/DraggableScroll'
import './index.scss'
import BaseSlidePopup from '../../BasicComponent/BaseSlidePopup'
import { CUSTOMER_GROUP } from '../../../constants/serviceOption'
import { CURRENT_APP_MODE_CONFIG } from '../../../constants/appMode'

export const checkDurationUsageDate = (duration, includeNumber = true) => {
  if (duration === 1) {
    return includeNumber ? '1 ngày' : '/ ngày'
  }
  if (duration === 7) {
    return includeNumber ? '1 tuần' : '/ tuần'
  }
  if (duration === 30) {
    return includeNumber ? '1 tháng' : '/ tháng'
  } else {
    return includeNumber ? `${duration || ''} ngày` : `/ ${duration || ''} ngày`
  }
}

const getProductOptionalInfo = (item) => {
  const value = item?.productOptionalInfo
  if (!value) return {}
  if (typeof value === 'object') return value

  try {
    return JSON.parse(value)
  } catch {
    return {}
  }
}

export default function AutomatedTrafficFineNotificationServiceCard({ title, description, list, onSelectService, vehicleType }) {
  const [detailService, setDetailService] = useState(null)

  return list?.length > 0 ? (
    <div className="AutomatedTrafficFineNotificationServiceCard">
      {title && <div className="AutomatedTrafficFineNotificationServiceCard_title">{title}</div>}
      {description && <div className="AutomatedTrafficFineNotificationServiceCard_description">{description}</div>}
      <DraggableScroll>
        <div className="AutomatedTrafficFineNotificationServiceCard_list">
          {list.map((item, index) => {
            // Get customer group label from productCustomerGroup
            const customerGroup = CUSTOMER_GROUP[item.productCustomerGroup] || item.productCustomerGroup
            const serviceDescription = CURRENT_APP_MODE_CONFIG.getServiceDescription({
              item,
              customerGroup,
              checkDurationUsageDate,
              getProductOptionalInfo
            })

            const servicePrice = CURRENT_APP_MODE_CONFIG.getServicePrice(item)

            const shouldShowDurationSuffix = CURRENT_APP_MODE_CONFIG.shouldShowDurationSuffix({
              item,
              customerGroup
            })
            return (
              <div
                className={`AutomatedTrafficFineNotificationServiceCard_item ${
                  CURRENT_APP_MODE_CONFIG.serviceCardClassName
                } ${item?.isSelected ? 'AutomatedTrafficFineNotificationServiceCard_item_active' : ''}`}
                key={index}>
                <IconAutomatedTrafficFineNotificationServicesSelected className="AutomatedTrafficFineNotificationServiceCard_item_selected" />
                <div className="AutomatedTrafficFineNotificationServiceCard_item_title">{item.productName}</div>
                <div className="AutomatedTrafficFineNotificationServiceCard_item_content">
                  <div className="AutomatedTrafficFineNotificationServiceCard_item_type">
                    <IconAutomatedTrafficFineNotificationServicesType />
                    <div className={CURRENT_APP_MODE_CONFIG.serviceCardDescriptionClassName}>
                      {serviceDescription}
                    </div>
                  </div>
                  <div className="AutomatedTrafficFineNotificationServiceCard_item_type">
                    <IconAutomatedTrafficFineNotificationServicesMoney />
                    <div>
                      <span>{number_to_price(servicePrice)}</span>
                      {shouldShowDurationSuffix && <span className="duration">{checkDurationUsageDate(item?.usageDate, false)}</span>}
                    </div>
                  </div>
                  <div className="AutomatedTrafficFineNotificationServiceCard_item_detail" onClick={() => setDetailService(item)}>
                    Chi tiết
                  </div>
                  <div className="AutomatedTrafficFineNotificationServiceCard_item_button" onClick={() => onSelectService(item, vehicleType)}>
                    {item?.isSelected ? 'Đã chọn' : 'Chọn'}
                  </div>
                </div>
              </div>
            )
          })}
        </div>
      </DraggableScroll>
      <BaseSlidePopup
        isOpen={detailService}
        onClose={() => setDetailService(null)}
        title={'Chi tiết'}
        textButton={'Chọn'}
        onConfirm={() => {
          if (!detailService?.isSelected) {
            onSelectService(detailService, vehicleType)
          }
          setDetailService(null)
        }}>
        <div className="AutomatedTrafficFineNotificationServiceDetail">
          {detailService?.productDescription ? (
            <div dangerouslySetInnerHTML={{ __html: detailService.productDescription }} />
          ) : (
            <div>Không có thông tin chi tiết</div>
          )}
        </div>
      </BaseSlidePopup>
    </div>
  ) : (
    <></>
  )
}
